module.exports = __webpack_public_path__ + "static/media/arrow-up-red-stroke.6f164861.svg";